import React, { useEffect } from 'react'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import ServicesTextContent from '../components/ServicesTextContent/ServicesTextContent'
import FaqSection from '../components/FaqSection/FaqSection'
import PlainBgText from '../components/PlainBgText/PlainBgText'
import { useLocation } from 'react-router-dom'
import PartnerCompanies from '../components/PartnerCompanies/PartnerCompanies'
import { Helmet } from 'react-helmet'

const AccountingServicesData = [
    {
        icon:"/images/icons/at-as-card-1.svg",
        title:"Bookkeeping & Financial Reporting",
        listPoint:[
            "Full-cycle bookkeeping (monthly, quarterly, yearly",
            "Financial statement preparation",
            "Accounts payable & receivable management",
            "Bank reconciliations",
            "Cash flow monitoring & forecasting",
            "Year-end closing & adjustments",
        ]
    },
    {
        icon:"/images/icons/at-as-card-2.svg",
        title:"Payroll & Compliance",
        listPoint:[
            "Payroll processing and reporting",
            "Direct deposits & pay stubs",
            "T4, T5, and ROE filings",
            "WSIB, CPP, EI & statutory remittances",
            "Employee benefit deductions and remittances",
        ]
    },
    {
        icon:"/images/icons/at-as-card-3.svg",
        title:"Government Filings & Compliance",
        listPoint:[
            "GST/HST filings and remittances",
            "WSIB & EHT compliance",
            "Record-keeping & document organization",
            "Audit support and CRA compliance",
        ]
    },
]

const TaxServicesData = [
    {
        icon:"/images/icons/at-ts-card-1.svg",
        title:"Corporate Tax Services",
        listPoint:[
            "Corporate tax return preparation (T2)",
            "Tax deductions and credits maximization",
            "Year-end tax filing & corporate tax planning",
            "CRA audit representation",
        ]
    },
    {
        icon:"/images/icons/at-ts-card-2.svg",
        title:"Personal Tax Services",
        listPoint:[
            "Personal tax return preparation (T1)",
            "Self-employed & freelance tax services",
            "Rental property tax reporting",
            "Retirement & investment tax strategies",
        ]
    },
    {
        icon:"/images/icons/at-ts-card-3.svg",
        title:"Tax Planning & Strategy",
        listPoint:[
            "Small business tax optimization",
            "Business structure tax efficiency (Incorporation vs. Sole Proprietor)",
            "Tax deferral strategies",
            "Estate & succession tax planning",
        ]
    }
]

const WhyChooseData = [
    {
        icon:"/images/icons/at-wc-card-1.svg",
        title:"Experienced Professionals ",
        content:"Decades of accounting & tax expertise."
    },
    {
        icon:"/images/icons/at-wc-card-2.svg",
        title:"Compliance & Accuracy ",
        content:"We ensure timely and accurate filings."
    },
    {
        icon:"/images/icons/at-wc-card-3.svg",
        title:"Tax Optimization ",
        content:"Minimize liabilities and maximize savings."
    },
    {
        icon:"/images/icons/at-wc-card-4.svg",
        title:"Personalized Solutions ",
        content:"Custom strategies tailored to your needs."
    },

]

const faqData = [
  {
    "title": "What is Financial Statement Analysis, and why does my business need it?",
    "content": "Financial Statement Analysis interprets your balance sheet, income statement, and cash-flow data to reveal profitability, liquidity, and operational efficiency trends. Knowing these metrics lets you spot hidden risks, benchmark performance, and prioritize improvements—vital for lenders, investors, and internal decision-making."
  },
  {
    "title": "How often should we have our financial statements analyzed?",
    "content": "Quarterly analysis is ideal for most mid-size businesses. It captures seasonal swings and gives you enough time to act on recommendations before the next reporting cycle. High-growth or capital-intensive companies may benefit from monthly reviews."
  },
  {
    "title": "What deliverables will I receive from Lotus Accounting’s Budgeting & Forecasting service?",
    "content": "You’ll receive (a) a detailed, driver-based budget, (b) 12- to 24-month financial forecasts, (c) variance-analysis templates, and (d) a set of KPIs linked to your goals. We also provide a walkthrough session so you can update assumptions as the year unfolds."
  },
  {
    "title": "How accurate are your forecasts?",
    "content": "Our CPA-led team combines historical data, industry benchmarks, and scenario modeling to keep forecast variance within 5–10% for most clients. We revisit assumptions quarterly to refine projections as market conditions change."
  },
  {
    "title": "What’s included in your Business Plan & Cash-Flow Projections package?",
    "content": "You receive an investor-ready business plan, complete with market analysis, financial strategy, and five-year cash-flow projections. We also create stress-tested scenarios so you can see how funding, pricing, or cost changes affect liquidity."
  },
  {
    "title": "Can Lotus Accounting help secure financing after creating the business plan?",
    "content": "Yes. We assist with pitch-deck refinement, lender presentations, and answering due-diligence questions, increasing your chances of approval."
  },
  {
    "title": "Which business structure should I choose when incorporating?",
    "content": "The optimal structure—Corporation, Partnership, or Sole Proprietorship—depends on liability concerns, tax planning, and future funding needs. During our incorporation consultation, we evaluate your goals and recommend the structure that maximizes tax efficiency and legal protection."
  },
  {
    "title": "How long does the incorporation and registration process take?",
    "content": "A straightforward provincial or federal incorporation typically takes 2–3 business days once all information is provided. More complex structures (e.g., multiple shareholders, holding companies) may take slightly longer due to additional documentation and CRA registrations."
  },
  {
    "title": "What are the ongoing compliance obligations after incorporation?",
    "content": "You’ll need to (a) file annual returns, (b) maintain minute books, (c) submit corporate tax (T2) filings, and (d) keep up with GST/HST and payroll remittances. Lotus Accounting offers packages that handle all these tasks so you stay compliant year-round."
  },
  {
    "title": "How do I get started?",
    "content": "Book a free consultation via our website or call +1 416-904-2013. We’ll assess your needs and outline a customized plan—whether it’s a one-time engagement or a full outsourced finance function."
  }
]

function ConsultingServices() {
 const { hash } = useLocation();
 
   useEffect(() => {
     if (hash) {
       const el = document.querySelector(hash);
       if (el) {
         el.scrollIntoView({ behavior: "smooth" });
       }
     }
   }, [hash]);
  return (
     <>
     <Helmet>
                     <link rel="canonical" href="https://www.lotusaccounting.ca/consulting-services" />
                     <title>
          Financial Consulting Services in Toronto | Lotus Accounting
        </title>
        <meta
          name='description'
          content='Expert financial consulting in Toronto including budgeting, forecasting, financial analysis, business plans, cash flow projections, and business incorporation.'>
        </meta>
                   </Helmet>
        <CommonBanner
         subHeading=""
         Heading="Strategic Financial Consulting & Advisory Services"
         Paragraph="From detailed financial-statement analysis and forward-looking budgets to cash-flow projections and seamless business incorporation, Lotus Accounting’s experts deliver data-driven guidance that positions your company for confident growth and long-term success."
         btnText=""
         bgImg="/images/creative/consulting-services-bg.jpg"
         btn={false}
         textWidthFull={true}
        />
        {/* <PartnerCompanies/> */}

       
       <div id="financialstatement">
          <ServicesTextContent
              heading={"Financial Statement Analysis"}
              content={"Explore the fundamental layers of your business's financial well-being through Lotus Accounting's Financial Statement Analysis service. Our seasoned professionals conduct a meticulous examination, unveiling key insights from your statements. Identifying strengths and pinpointing areas for improvement, we equip you with a clear understanding, empowering you to make informed decisions for the sustained success of your enterprise."}
              img={'/images/creative/services-1.png'}
              shiftRow={false}
              bgColor={"#ffffff"}
              
            btnRef="/contact"
            
            btnCalendly={true}
          />
        </div>

        <div id="budgetforecasting">
        <ServicesTextContent
            heading={"Budgeting & Forecasting"}
            content={"Propel your business towards success with precision through Lotus Accounting's Budgeting & Forecasting consultation services. We empower you to craft realistic budgets and forecasts, granting you control over your financial future. By setting achievable goals and proactively managing resources, our guidance ensures strategic financial planning that aligns with your business objectives, fostering sustained growth and stability."}
            img={'/images/creative/services-2.png'}
            shiftRow={true}
            bgColor={"#F8F8F8"}
            
            btnRef="/contact"
            
            btnCalendly={true}
        />
        </div>
        {/* <AboutHistory/> */}

        <div id="bussinessplan">
        <ServicesTextContent
            heading={"Business Plan & Cash Flow Projections"}
            content={"Create a strategic roadmap with Lotus Accounting's Business Plan & Cash Flow Projections service. Our experts collaborate with you to craft comprehensive business plans and accurate cash flow projections. Whether you're launching a new venture or expanding an existing one, we facilitate the articulation of your goals, ensuring a financially sound and prosperous future for your business."}
            img={'/images/creative/services-3.png'}
            shiftRow={false}
            bgColor={"#ffffff"}
            
            btnRef="/contact"
            
            btnCalendly={true}
        />
        </div>

         <div id="bussinessincorpration">
          <ServicesTextContent
              heading={"Business Incorporation & Registration"}
              content={"Navigate the complex stages of business incorporation with assurance, benefiting from the expert guidance provided by Lotus Accounting. Our experts provide comprehensive assistance, addressing both legal and financial aspects of establishing your business entity. From selecting the optimal structure to fulfilling registration requirements, we ensure a seamless process. Trust us to lay the foundation for your business success through meticulous incorporation and registration services."}
              img={'/images/creative/services-4-new.png'}
              shiftRow={true}
              bgColor={"#F8F8F8"}
              marginBottomNull={true}
              
            btnRef="/contact"
            
            btnCalendly={true}
          />
        </div>

        
      <PlainBgText
      
      />

       <FaqSection
            heading='Frequently Asked Questions (FAQs)'
            faqData={faqData}
            btn={true}
            btnText="Get a Free Consultation "
        />
    </>
  )
}

export default ConsultingServices